import React from "react";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./../editor-common/index.js";
import { EditIcon, TrashIcon } from "./../toolbars-ui/index.js";
import {
  alwaysVisibleResolver,
  getAnchorLinkData,
  getUrlLinkData,
  isTextContainsAnchorResolver,
  isTextContainsLinkResolver
} from "./../toolbars-v3/index.js";
import {
  LINK_PLUGIN_EDIT_BUTTON,
  LINK_PLUGIN_REMOVE_BUTTON,
  LINK_PLUGIN_SCROLL_TO_ANCHOR_BUTTON,
  LINK_PLUGIN_WEB_LINK_BUTTON
} from "./data-hooks.js";
import { AnchorLinkButton } from "./toolbar/anchor-link-button.js";
import { EditLinkButton } from "./toolbar/edit-link-button.js";
import { RemoveLinkButton } from "./toolbar/remove-link-button.js";
import { UrlLinkButton } from "./toolbar/url-link-button.js";
const getToolbarButtons = () => {
  return [
    {
      id: "anchorLink",
      type: "toggle",
      dataHook: LINK_PLUGIN_SCROLL_TO_ANCHOR_BUTTON,
      attributes: {
        visible: isTextContainsAnchorResolver,
        selectedAnchorLinkData: getAnchorLinkData
      },
      command: ({ tiptapEditor, attributes: { selectedAnchorLinkData } }) => {
        tiptapEditor.commands.scrollToAnchor(selectedAnchorLinkData);
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(AnchorLinkButton, { toolbarItem })
    },
    {
      id: "urlLink",
      type: "toggle",
      dataHook: LINK_PLUGIN_WEB_LINK_BUTTON,
      attributes: {
        visible: isTextContainsLinkResolver,
        selectedUrlLinkData: getUrlLinkData
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(UrlLinkButton, { toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      type: "separator",
      attributes: {
        visible: alwaysVisibleResolver
      }
    },
    {
      id: "editLink",
      type: "toggle",
      dataHook: LINK_PLUGIN_EDIT_BUTTON,
      tooltip: "LinkTo_Edit_Tooltip",
      icon: EditIcon,
      attributes: {
        visible: alwaysVisibleResolver
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(EditLinkButton, { toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      type: "separator",
      attributes: {
        visible: alwaysVisibleResolver
      }
    },
    {
      id: "removeLink",
      type: "toggle",
      dataHook: LINK_PLUGIN_REMOVE_BUTTON,
      tooltip: "LinkPanelContainer_RemoveButton",
      icon: TrashIcon,
      attributes: {
        visible: isTextContainsLinkResolver
      },
      command: ({ tiptapEditor }) => {
        tiptapEditor.chain().focus().unsetLink().run();
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(RemoveLinkButton, { toolbarItem })
    },
    {
      id: "removeAnchor",
      type: "toggle",
      dataHook: LINK_PLUGIN_REMOVE_BUTTON,
      tooltip: "LinkPanelContainer_RemoveButton",
      icon: TrashIcon,
      attributes: {
        visible: isTextContainsAnchorResolver
      },
      command: ({ tiptapEditor }) => {
        tiptapEditor.chain().focus().unsetAnchor().run();
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(RemoveLinkButton, { toolbarItem })
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=get-toolbar-buttons.js.map
